<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (!isModal) {
        <ion-button [routerLink]="['/inventory/beer']">
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    @if (beverage$ |async; as beverage) {
      <ion-buttons slot="end">
        @if (isModal) {
          <ion-button (click)="closeModal()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        }
        @if (!isModal) {
          <ion-button (click)="confirmAlert(beverage)" data-testid="beer-detail-delete">
            <ion-icon slot="icon-only" color="danger" name="trash-outline">
            </ion-icon>
          </ion-button>
        <ion-button (click)="openHelpModal()">
          <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
        </ion-button>
      }
      </ion-buttons>
    }
    @if ((beverage$ | async)?.name) {
      <ion-title
        >{{(beverage$ | async)?.name}}</ion-title>
      }
      @if (!(beverage$ | async)?.name) {
        <ion-title>Add</ion-title>
      }
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <app-form
      [item]="beverage$ | async"
      [uid]="uid$ | async"
      [allBeerStyles]="beerstyles$ | async"
      [allKegs]="kegs$ | async"
      [attachedKegs]="attachedKegs$ | async"
      [locations]="locations$ | async"
      [unitTypes]="unitTypes$ | async"
      [isPremium]="isPremium$ | async"
      [externalApiSettings]="externalApiSettings$ | async"
      (softUpdateBeverage)="softUpdateBeverage($event)"
      (softUpdateKeg)="softUpdateKeg($event)"
      (deleteBeerstyle)="deleteBeerstyle($event)"
      (addBeerstyle)="addBeerstyle($event)"
      (removeKegFromBeverage)="removeKegFromBeverage($event)"
    ></app-form>
  </ion-content>
